import React, { createContext, useContext, useEffect, useState } from 'react';
import { publicAPI } from '../services/api';

interface SystemSettings {
  phone: string;
  email: string;
  address: string;
  operatingHours: string;
  minimumAge: string;
  shelterName: string;
  website: string;
  facebookUrl: string;
  instagramUrl: string;
  city: string;
}

interface SystemSettingsContextType {
  settings: SystemSettings | null;
  loading: boolean;
  error: string | null;
}

const SystemSettingsContext = createContext<SystemSettingsContextType>({
  settings: null,
  loading: true,
  error: null,
});

export const useSystemSettings = () => {
  const context = useContext(SystemSettingsContext);
  if (!context) {
    throw new Error('useSystemSettings must be used within a SystemSettingsProvider');
  }
  return context;
};

interface SystemSettingsProviderProps {
  children: React.ReactNode;
}

export const SystemSettingsProvider: React.FC<SystemSettingsProviderProps> = ({ children }) => {
  const [settings, setSettings] = useState<SystemSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await publicAPI.getSystemSettings();
        setSettings(response.data);
      } catch (err) {
        console.error('Error fetching system settings:', err);
        setError('Failed to load system settings');
        // Fallback to default values
        setSettings({
          phone: '+40 750 209 751',
          email: 'protectiaanimalelor@primarias1.ro',
          address: 'Sos. Odăi, nr. 3-5, Sector 1, București',
          operatingHours: 'Luni - Vineri: 10:00 - 18:00',
          minimumAge: '18',
          shelterName: 'Adăpostul Odăi',
          website: 'www.adoptadinodai.ro',
          facebookUrl: 'https://www.facebook.com/profile.php?id=61572807361488',
          instagramUrl: 'https://www.instagram.com/protectiaanimalelor.sector1',
          city: 'București'
        });
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return (
    <SystemSettingsContext.Provider value={{ settings, loading, error }}>
      {children}
    </SystemSettingsContext.Provider>
  );
}; 